import React, { useState, useEffect } from 'react';
import axiosConn from '../../axiosConn';
import getAddressFromCoordinates from '../../utils/getAddressFromCoordinates';

const FilterBar = ({ filters, onFilterChange, player }) => {
  const [cities, setCities] = useState([]);
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showGeoConfirm, setShowGeoConfirm] = useState(false);
  const [geoCity, setGeoCity] = useState('');

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const response = await axiosConn.get('hunts/filters', {
          headers: {
            Authorization: `Bearer ${player?.token}`,
          },
        });
        setCities(response.data.cities || []);
        setRegions(response.data.regions || []);
      } catch (err) {
        console.error('Error fetching filter options:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchFilters();
  }, [player]);

  const handleCityChange = (e) => {
    onFilterChange({ ...filters, city: e.target.value });
  };

  const handleRegionChange = (e) => {
    onFilterChange({ ...filters, region: e.target.value });
  };

  const handleReset = () => {
    onFilterChange({ city: '', region: '' });
  };

  const handleGeoLocation = async () => {
    if (!navigator.geolocation) {
      alert('Geolocation not supported.');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const { latitude, longitude } = position.coords;
          const address = await getAddressFromCoordinates(latitude, longitude);
          const cityFromGeo = address.city;
          console.log('Geolocation resolved to city:', cityFromGeo);
          setGeoCity(cityFromGeo);
          setShowGeoConfirm(true);
        } catch (err) {
          console.error('Error resolving location:', err);
        }
      },
      (err) => {
        console.error('Geolocation error:', err);
        alert('Could not determine your location.');
      },
    );
  };

  const confirmLocation = () => {
    onFilterChange({ ...filters, city: geoCity });
    setShowGeoConfirm(false);
  };

  if (loading)
    return <div className="text-center my-3">Loading filters...</div>;

  //   console.log('FilterBar rendered with filters:', filters);
  //   console.log('Available cities:', cities);
  //   console.log('Available regions:', regions);
  return (
    <div className="container my-3">
      <div className="row align-items-end">
        <div className="col-md-4 mb-2">
          <label htmlFor="cityFilter" className="form-label">
            City
          </label>
          <select
            id="cityFilter"
            className="form-select"
            value={filters.city}
            onChange={handleCityChange}
          >
            <option value="">All Cities</option>
            {cities.map((city) => (
              <option key={city} value={city}>
                {city}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-4 mb-2">
          <label htmlFor="regionFilter" className="form-label">
            Region
          </label>
          <select
            id="regionFilter"
            className="form-select"
            value={filters.region}
            onChange={handleRegionChange}
          >
            <option value="">All Regions</option>
            {regions.map((region) => (
              <option key={region} value={region}>
                {region}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-4 mb-2 d-flex gap-2">
          <button className="btn btn-secondary w-100" onClick={handleReset}>
            🔄 Reset Filters
          </button>
          <button
            className="btn btn-outline-primary w-100"
            onClick={handleGeoLocation}
          >
            📍 Use My Location
          </button>
        </div>
      </div>

      {showGeoConfirm && (
        <div className="alert alert-info mt-3 d-flex justify-content-between align-items-center">
          <div>
            Are you in <strong>{geoCity}</strong>?
          </div>
          <button className="btn btn-sm btn-success" onClick={confirmLocation}>
            Yes
          </button>
        </div>
      )}
    </div>
  );
};

export default FilterBar;
